import { ref } from 'vue'

// Module-level, not per-instance: navigator.onLine and the online/offline
// events are global browser state, so every consumer (the offline banner,
// the upload auto-retry in useVoicePlanUpload) should observe the same
// shared ref rather than each registering its own listener pair.
const isOnline = ref(navigator.onLine)

function updateOnlineStatus(): void {
  isOnline.value = navigator.onLine
}

window.addEventListener('online', updateOnlineStatus)
window.addEventListener('offline', updateOnlineStatus)

export function useNetworkStatus() {
  return { isOnline }
}
